import {ModalEvents} from "../components/style-guide/modal/ModalEvents";
import eventBus from "infrastructure/common/eventBus";

export const ModalHelper = class {
  static open(title, content, onClose, ...props) {
    eventBus.dispatch(ModalEvents.OPEN, {content, title, onClose, ...props});
  }

  static close() {
    eventBus.dispatch(ModalEvents.CLOSE);
  }
};
